import React from 'react'
import { ReactComponent } from './linkedin.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface LinkedinProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', LinkedinProps>

export const LinkedinIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
